export const ApiLogin = "https://mppl-dash.aliazhar.my.id/api/v1/login";
export const ApiRegister = "https://mppl-dash.aliazhar.my.id/api/v1/register";
